module.exports = __webpack_public_path__ + "static/index-34fdcd5966bd0546e8b614cf3b6235ec.jpg";